/**
 * The four panels, one row each, each pictured by its screen with the cards
 * that float over it (`@/assets/images/panels`).
 */
import panelAdmin from '@/assets/images/panels/admin.webp'
import panelHr from '@/assets/images/panels/hr.webp'
import panelReception from '@/assets/images/panels/reception.webp'
import panelUser from '@/assets/images/panels/user.webp'

export const PANELS = {
  eyebrow: 'One app',
  title: 'Four panels, one schedule',
  text: 'Each role sees what it needs. Everything stays in sync.',
  items: [
    {
      title: 'User panel',
      tag: 'Book & join',
      image: panelUser,
      text: 'Schedule meetings, pick rooms, see invites and your week on one calendar.',
      rows: [
        { label: 'For', value: 'Everyone in the team' },
        { label: 'Includes', value: 'Calendar, rooms, invites, messages' },
      ],
    },
    {
      title: 'Reception panel',
      tag: 'Front desk',
      image: panelReception,
      text: 'Walk-in sign-in with signatures, VIP guests, who is in today and host alerts.',
      rows: [
        { label: 'For', value: 'Reception staff' },
        { label: 'Includes', value: 'Visitors, walk-ins, VIP, host alerts' },
      ],
    },
    {
      title: 'HR panel',
      tag: 'Approvals',
      image: panelHr,
      text: 'Approve room requests and new members, and keep an eye on how rooms are used.',
      rows: [
        { label: 'For', value: 'HR team' },
        { label: 'Includes', value: 'Requests, members, reports' },
      ],
    },
    {
      title: 'Admin panel',
      tag: 'Setup',
      image: panelAdmin,
      text: 'Set up rooms, branches, roles and company details in one place.',
      rows: [
        { label: 'For', value: 'Admins' },
        { label: 'Includes', value: 'Rooms, roles, settings' },
      ],
    },
  ],
}
